// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"661651eb","280":"a74944ec","437":"2b877881","629":"f72e8f41","945":"1af2ccbc"}[chunkId] + ".chunk.css";
};